import Marionette from "backbone.marionette";
import $ from "jquery";

import { RESUME_STORAGE_KEY } from "lib/constants";
import wsStorage from "lib/wsStorage";

import util from "../../util";
import config from "../../config";

import modalTemplate from "../../templates/steps/resumeModal.jst";
import uploadTemplate from "../../templates/steps/resume-upload.jst";

const VALID_FILES = ["doc", "docx", "pdf"];

export const ResumeUpload = Marionette.View.extend({
    template: uploadTemplate,

    ui: {
        attachedOptions: "#attached-resume-options",
        changedResume: "#change-upload",
        invalidFile: ".invalid-resume-file-alert",
        offerOptions: "#offer-attach-options",
        parseResume: ".parse-resume",
        removeResume: "#remove-resume",
        resumeFileName: ".resume-file-name",
        resumeUpload: ".js-resume-upload",
        resumeWarning: ".resume-warning",
    },

    events: {
        "change @ui.resumeUpload": "onUploadResume",
        "change @ui.changedResume": "onChangeResume",
        "click @ui.removeResume": "onRemoveResume",
        "click @ui.parseResume": "onParseResume",
    },

    onRender() {
        this.canClose = true;

        this.ui.attachedOptions.hide();
        this.ui.offerOptions.show();

        if (this.model.get("jobs").length === 0) {
            this.ui.resumeWarning.hide();
        }
    },

    onChangeResume() {
        this.setFile(this.ui.changedResume);
    },

    onUploadResume() {
        this.ui.offerOptions.hide();
        this.ui.attachedOptions.show();

        this.canClose = true;
        this.setFile(this.ui.resumeUpload);
    },

    setFile(field) {
        this.fileData = field[0].files[0];
        this.ui.resumeFileName.text(this.fileData.name);
        this.validateFile();
    },

    validateFile() {
        this.fileType = this.fileData.name.split(".");
        this.fileType = this.fileType[this.fileType.length - 1];

        if (VALID_FILES.indexOf(this.fileType) > -1) {
            this.ui.invalidFile.hide();
            this.saveResume();
        } else {
            this.ui.parseResume.disable();
            this.ui.invalidFile.show();
        }
    },

    saveResume() {
        this.ui.parseResume.disable();

        util.resumeSave(this.fileData).then(
            (data) => {
                this.model.set({
                    resume_status: config.RESUME_STATUS.ADDED,
                    resume_location: data,
                });
                this.ui.parseResume.enable();
            },
            () => {
                this.model.set({
                    resume_status: null,
                    resume_location: null,
                });
                this.ui.parseResume.enable();
            },
        );
    },

    onRemoveResume() {
        // don't let them close the modal if they hit next to start parsing
        if (this.canClose) {
            this.model.set({
                resume_status: null,
                resume_location: null,
            });

            this.ui.changedResume.val("");
            this.ui.resumeUpload.val("");
            this.ui.resumeFileName.text("");

            this.ui.attachedOptions.hide();
            this.ui.offerOptions.show();

            this.trigger("resume:remove");
        }
    },

    onParseResume() {
        this.canClose = false;
        this.ui.changedResume.disable();

        this.trigger("start-resume-parse");

        this.ui.parseResume.loading(true);
        wsStorage.setItem(RESUME_STORAGE_KEY, true, 300000);

        // wait 7 seconds while the resume parsing takes place - then load jobs
        // adds a parameter to bypass steps going to review on refresh
        // forgive me
        setTimeout(() => {
            if (this.options.isProfile && !this.options.isReview) {
                window.location.hash = "history";
                window.location.reload();
            } else {
                const { KEY, VALUE } = config.RESUME_GET_PARAM_FOR_RELOAD;
                window.location.search = util.updateQueryParam({
                    [KEY]: VALUE,
                });
            }
        }, 7000);
    },
});

export const ResumeUploadModal = Marionette.View.extend({
    template: modalTemplate,
    ui: {
        attachedResume: "#resume-attached-overlay",
        attachedModal: "#resume-attached-modal",
        resume: ".js-resume",
    },
    onRender() {
        this.view = new ResumeUpload({
            el: this.ui.resume,
            model: this.model,
        });
        this.listenTo(this.view, "all", this.trigger);
        this.listenTo(this.view, "resume:remove", () => {
            this.ui.attachedResume.fadeOut(350, () => {
                $(document).off("mouseup.resumeModal");
            });
        });
        this.view.render();
    },
    showModal() {
        this.ui.attachedResume.fadeIn(350);

        // close modal if user clicks outside of it
        $(document).on("mouseup.resumeModal", (e) => {
            // if the target of the click isn't the container nor a descendant of the container
            if (!$(e.target).closest(this.ui.attachedModal).length) {
                this.view.onRemoveResume();
            }
        });
    },
});
